// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__82sGT","tyre":"style_tyre__bR4wm"};